var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"file-preview-image-container images"},[_c('img',{staticStyle:{"max-width":"100%","max-height":"92.5%"},attrs:{"src":_vm.getProxyConvertedURL(_vm.fileUrl),"alt":""},on:{"error":_vm.replaceByDefaultImage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }